import React from 'react';
import { proofStats, shortQuotes } from '../data/content';
export function ProofStrip() {
  return <section aria-label="Resultados y opiniones rápidas" className="border-b border-line bg-sand" data-id="element-195" data-mp="3g9p6xuw1c618">
      <div className="mx-auto max-w-6xl px-5 py-12" data-id="element-196" data-mp="3ba4abr4c89ro">
        <dl className="grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-197" data-mp="3b8t1vdzy6du8">
          {proofStats.map(stat => <div key={stat.label} className="border-l-2 border-accent/40 pl-4" data-id="element-198" data-mp="7u5g12iu6zpc">
              <dt className="sr-only" data-id="element-199" data-mp="7s2rkmxc1emq">{stat.label}</dt>
              <dd data-id="element-200" data-mp="2w42ex46jsl9">
                <span className="block font-display text-3xl font-semibold leading-none text-ink" data-id="element-201" data-mp="2vluh385npxi">
                  {stat.value}
                </span>
                <span className="mt-2 block text-[13px] leading-snug text-ink-soft" data-id="element-202" data-mp="3q0bhhaowa6d2">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 grid gap-8 border-t border-line pt-10 lg:grid-cols-3" data-id="element-203" data-mp="2ek3nhxnj43d0">
          {shortQuotes.map(item => <figure key={item.author} className="flex h-full flex-col" data-id="element-204" data-mp="3bbrmbpilrpgm">
              <blockquote className="font-display text-[17px] italic leading-snug text-ink" data-id="element-205" data-mp="3gacrm3cpozbx">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-4 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-206" data-mp="329s8t76sr3if">
                {item.author}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}